// src/components/SecondaryMarketPage.jsx
import React from "react";
// import "./SecondaryMarketPage.scss";

const SecondaryMarketPage = () => {
  return (
    <div className="secondary-market">
      <h2>Trade Tokens on Secondary Market</h2>
      <div>
        <h3>Market Stats</h3>
        <p>Real-time data on token price and trade volume.</p>
      </div>
      <div>
        <h3>Trade Section</h3>
        <button>Sell Tokens</button>
        <button>Buy Tokens</button>
      </div>
    </div>
  );
};

export default SecondaryMarketPage;
